/**
 * ⌨ 상단 검색창 단축키 — Ctrl+F · Ctrl+K (v2.322.0 · 개발요청 #33 한진영 · 사용자 결정 「A안 + Ctrl+K」 2026-11-02)
 *
 *   Ctrl+F  한 번   = 상단 검색창으로(글자가 있으면 전부 골라 둔다 — 바로 새로 치면 바뀐다)
 *           검색창에서 한 번 더 = 브라우저 찾기(화면 안 글자 찾기 — 긴 표에서 쓰던 길을 잃지 않게)
 *   Ctrl+K  언제나 상단 검색창으로(검색창에 있어도 브라우저 주소창으로 새지 않게 막는다)
 *   ⛔작성 창(팝업)이 하나라도 열려 있으면 두 키 다 **그대로 브라우저에** — 창 안의 글자를 찾던 사람이 창 뒤 검색창으로 끌려가지 않게.
 *   ⛔검색창이 안 보이면(폰 화면 · 헤더는 PC 에만 있다) 그대로 브라우저에.
 *   맥은 Cmd 가 Ctrl 자리 · Shift·Alt 가 같이 눌리면(Ctrl+Shift+F 등 다른 뜻) 건드리지 않는다.
 *
 * ⭐판정은 이 순수 함수 한 곳에서만 — 화면(TopBar)은 이것을 부르고, 검사 그물(scripts/check-search-hotkey.ts)도 이것을 부른다.
 */

export interface HotkeyEventLike {
  key: string;
  /** 자판 자리 — 한글 입력 상태에서는 key 가 「ㄹ」 처럼 올 수 있어 자리(KeyF)로도 본다 */
  code?: string;
  ctrlKey: boolean;
  metaKey: boolean;
  altKey: boolean;
  shiftKey: boolean;
}

export interface HotkeyContext {
  /** 지금 상단 검색창에 커서가 있나 */
  inSearch: boolean;
  /** 상단 검색창 말고 열려 있는 창(팝업) 수 — lib/dialog-stack 의 쌓인 수에서 검색 목록 자기 층을 뺀 것 */
  otherDialogs: number;
  /** 상단 검색창이 화면에 보이나 (폰 화면이면 false) */
  searchVisible: boolean;
}

/** focus = 막고 상단 검색창으로 · pass = 아무것도 안 함(브라우저 그대로) */
export type HotkeyAction = 'focus' | 'pass';

function which(e: HotkeyEventLike): 'f' | 'k' | null {
  const k = (e.key ?? '').toLowerCase();
  if (k === 'f' || e.code === 'KeyF') return 'f';
  if (k === 'k' || e.code === 'KeyK') return 'k';
  return null;
}

export function searchHotkeyAction(e: HotkeyEventLike, ctx: HotkeyContext): HotkeyAction {
  if (!(e.ctrlKey || e.metaKey) || e.altKey || e.shiftKey) return 'pass';
  const w = which(e);
  if (!w) return 'pass';
  if (!ctx.searchVisible || ctx.otherDialogs > 0) return 'pass';
  if (w === 'f' && ctx.inSearch) return 'pass';
  return 'focus';
}
